import {
  Component,
  ElementRef,
  ViewChild,
  OnInit,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { NotificationService } from '../../../../services/notifications';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-offers',
  template: `
    <div class="swiper" #swiperContainer *ngIf="slides.length > 0">
      <div class="swiper-wrapper">
        <div class="swiper-slide" *ngFor="let s of slides">
          <a [href]="s.link">
            <img [src]="s.img" alt="{{ s.title }}" />
          </a>
          <div class="caption">
   
            <p>{{ s.subtitle }}</p>
          </div>
        </div>
      </div>

      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  `,
  styleUrls: ['./offers.component.scss']
})
export class OffersComponent implements OnInit {
//         <h3>{{ s.title }}</h3>
  @ViewChild('swiperContainer', { static: false }) swiperEl!: ElementRef;

  isMobile = false;
  isAr = false;
  notifications: any[] = [];
  slides: any[] = [];
  contentReady = true;
  noData = false;

  swiper?: Swiper;
  private isBrowser: boolean;

  constructor(
    private notificationService: NotificationService,
    private deviceService: DeviceDetectorService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    // ⛔ السيرفر يقف هنا
    if (!this.isBrowser) {
      return;
    }

    // Browser only
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem('language') === 'ar';

    this.loadNotifications();
  }

  loadNotifications(): void {
    this.contentReady = true;

    this.notificationService.getAllNotifications().subscribe({
      next: (data) => {
        this.notifications = data || [];
        this.noData = this.notifications.length === 0;
        this.contentReady = false;

        // تحويل notifications → slides
        this.slides = this.notifications.map((n: any) => ({
          img: this.isMobile
            ? this.fixImage(n.mobile_image)
            : this.fixImage(n.image),
          title: this.isAr ? n.notification_head_ar : n.notification_head_en,
          subtitle: this.isAr ? n.notification_body_ar : n.notification_body_en,
          link: n.link
        }));

        // Swiper لازم يتعمل بعد ما الـ DOM يتحدث
        setTimeout(() => this.initSwiper(), 0);
      },
      error: (err) => {
        console.error('Error loading notifications', err);
        this.contentReady = false;
        this.noData = true;
      },
    });
  }

  // ================= IMAGES =================
  fixImage(url: string): string {
    if (!url) return '/assets/default-banner.jpg';

    if (url.startsWith('http')) return url;

    url = url.replace(/^\/?storage\//, '');
    return `https://backendproduction.blueboxpet.com/storage/app/public/${url}`;
  }

  // ================= SWIPER =================
  private initSwiper(): void {
    if (!this.isBrowser || !this.swiperEl) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.swiperEl.nativeElement, {
      modules: [Navigation, Pagination, Autoplay],
      navigation: true,
      pagination: { clickable: true },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      loop: true,
      speed: 2000,
    });
  }
}
